<template>
	<v-flex>
		<v-autocomplete
			:clearable="isClearable"
			:error-messages="$props.error"
			:items="options"
			:label="$props.label"
			:placeholder="' '"
			:readonly="readonly"
			item-text="label" item-value="value" v-if="!isSimple"
			v-model="selectedValue">
			<template #prepend-item>
				<slot name="firstItem"></slot>
			</template>
			<template #prepend>
				<slot name="prepend"></slot>
			</template>

		</v-autocomplete>
		<v-autocomplete
			:clearable="isClearable"
			:items="options"
			:readonly="readonly"
			class="simple"
			hide-details item-text="label" item-value="value" v-if="isSimple"
			v-model="selectedValue">
			<template #prepend-item>
				<slot name="firstItem"></slot>
			</template>
			<template #prepend>
				<slot name="prepend"></slot>
			</template>

		</v-autocomplete>
	</v-flex>
</template>

<script>
	export default {
		name: "Dropdown",
		props: ['simple', 'readonly', 'value', 'ajax', 'data', 'label', 'error', 'clearable'],
		data() {
			return {
				endpoint: '',
				selectedValue: null,
				options: [],
				ajaxLoaded: false,
				protected: null
			}
		},
		computed: {
			isSimple() {
				return (typeof this.$props.simple !== 'undefined');
			},
			isClearable() {
				return (typeof this.$props.clearable !== 'undefined');
			}
		},
		watch: {
			value: function (newVal, oldVal) {
				if (newVal != oldVal) {
					if (newVal != this.selectedValue) {
						this.protected = newVal;
						this.setValue(newVal);
					}
				}
			},
			selectedValue: function (val) {
				if (val != this.$props.value) {
					if (val != null) {
						if (val != this.$props.value) {
							this.$nextTick(() => {
								this.$emit('input', val);
							})
						}
					} else {
						this.$nextTick(() => {
							this.$emit('input', null);
						})
					}
					this.$nextTick(() => {
						this.callChange();
					});
				}
			},
		},
		methods: {
			callChange() {
				this.$emit('changes');
			},
			setValue(newVal) {
				if (this.$props.ajax) {
					var vm = this;
					this.$APICall('get', 'select/' + this.endpoint, {protected: this.protected}, (data, success) => {
						if (success) {
							vm.options = data;
							vm.ajaxLoaded = true;
							vm.selectedValue = newVal;
						}
					}, false);

				} else {
					this.options = this.$props.data;
					this.selectedValue = newVal;
				}
			}
		},
		mounted() {
			this.$onReload(() => {
				var vm = this;
				this.$APICall('get', 'select/' + this.endpoint, {protected: this.protected}, (data, success) => {
					if (success) {
						vm.options = data;
					}
				}, false);
			});
			this.$modalBus.$on('RELOAD', message => {
				var vm = this;
				this.$APICall('get', 'select/' + this.endpoint, {protected: this.protected}, (data, success) => {
					if (success) {
						vm.options = data;
					}
				}, false);
			});
			if (this.$props.ajax) {
				this.endpoint = this.$props.data;
			}
			this.protected = this.$props.value;
			this.setValue(this.$props.value);
		}
	}
</script>

<style scoped>
	.simple {
		padding: 0px;
		margin: 0px;
	}
</style>
